"use client";

import { useEffect } from "react";

export const ServiceWorkerRegister = () => {
	useEffect(() => {
		if (typeof window === "undefined" || !("serviceWorker" in navigator)) {
			return;
		}

		const isCloudRun =
			window.location.hostname.includes("run.app") ||
			window.location.hostname.includes("cloudrun.app");

		if (isCloudRun) {
			console.warn(
				"Skipping service worker registration on Cloud Run environment",
			);
			return;
		}

		if (process.env.NEXT_PUBLIC_DEPLOY_ENV === "development") {
			console.log("Skipping service worker registration in development mode");
			return;
		}

		const registerServiceWorker = async () => {
			try {
				const swUrl = `${window.location.origin}/sw.js`;
				const existingRegistration =
					await navigator.serviceWorker.getRegistration();

				if (existingRegistration) {
					console.log(
						"Service Worker already registered:",
						existingRegistration,
					);
					return;
				}

				const registration = await navigator.serviceWorker.register(swUrl, {
					scope: "/",
				});
				console.log("Service Worker registered:", registration);
			} catch (error) {
				console.error("Service Worker registration failed:", error);
				if (error instanceof Error && error.message.includes("redirect")) {
					console.warn(
						"Service Worker registration failed due to redirect. This is a security restriction.",
					);
				}
			}
		};

		registerServiceWorker();
	}, []);

	return null;
};
